import numberToFixed from './numberToFixed'

export default function formatNumber(
  n: number,
  options: {
    thousandth?: boolean
    millionth?: boolean
    ceil?: boolean
    thousandLabel?: string
    millionLabel?: string
  } = {}
): string {
  if (!n) return '0'
  const {
    thousandth = true,
    millionth = true,
    ceil = true,
    millionLabel = 'млн.',
    thousandLabel = 'тыс.',
  } = options

  if (ceil) {
    n = Math.ceil(n)
  }

  if (millionth && n >= 1e6) {
    return `${numberToFixed(n / 1e6, 1)} ${millionLabel}`
  }

  if (thousandth && n >= 1e3) {
    return `${numberToFixed(n / 1e3, 1)} ${thousandLabel}`
  }

  return n.toLocaleString('ru-RU')
}
